import { Typography } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";

export default function QuestionAndAnswerListItem({ data }) {
  return (
    <div className="flex w-full flex-row gap-2 py-2">
      <div
        className="w-1/2 rounded-md p-2"
        style={{
          backgroundColor: HNSColors.tertiary[950],
        }}
      >
        <Typography className="w-full whitespace-normal break-words p-2 text-[12px] font-semibold">
          {data?.question}
        </Typography>
      </div>

      <div className="w-1/2 rounded-md p-2">
        <Typography className="w-full whitespace-normal break-words p-2 text-[12px] font-normal">
          {data?.answer}
        </Typography>
      </div>
    </div>
  );
}
